<template>
  <div>
    <link rel="preload" as="image" :href="secureUrl()" />
    <v-img
      ref="mediaImage"
      :src="secureUrl()"
      :class="classArray"
      :height="size"
      :width="size"
      @load="loadImage"
      ><div v-if="!isLoaded" class="progress">
        <v-progress-circular
          indeterminate
          color="#aaa"
        ></v-progress-circular></div
    ></v-img>
  </div>
</template>

<script>
import { forceSSL } from '@/helper/helper'

export default {
  name: 'MediaImage',
  props: {
    mediaSource: Object,
    size: Number,
    classArray: Array
  },
  data: () => ({
    isLoaded: false
  }),
  methods: {
    loadImage () {
      this.isLoaded = true
    },
    secureUrl () {
      return this.mediaSource.uri && forceSSL(this.mediaSource.uri)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media/image.vue